import { getRuntimeConfig } from '@/utils/runtime-config';

// Helper per ottenere la config in modo sicuro
function getConfig() {
  try {
    return getRuntimeConfig();
  } catch (e) {
    // Fallback durante il caricamento iniziale
    return null;
  }
}

const KEY = Object.freeze({
  ADD_LIQUIDITY: 'add_liquidity',
  DECREASE_ALLOWANCE: 'decrease_allowance',
  INCREASE_ALLOWANCE: 'increase_allowance',
  MINT: 'mint',
  REMOVE_LIQUIDITY: 'remove_liquidity',
  SWAP: 'swap',
  TRANSFER_NFT: 'transfer_nft',
  UPDATE_MARKETING: 'update_marketing',
});

// Fallback transaction types (used if config is not loaded or doesn't specify types)
const DEFAULT_SUPPORTED_TYPES = [
  {
    name: 'MsgBeginRedelegate',
    text: '/cosmos.staking.v1beta1.MsgBeginRedelegate',
  },
  {
    name: 'MsgCreateValidator',
    text: '/cosmos.staking.v1beta1.MsgCreateValidator',
  },
  {
    name: 'MsgDelegate',
    text: '/cosmos.staking.v1beta1.MsgDelegate',
  },
  {
    name: 'MsgEditValidator',
    text: '/cosmos.staking.v1beta1.MsgEditValidator',
  },
  {
    name: 'MsgExecuteContract',
    text: '/cosmwasm.wasm.v1.MsgExecuteContract',
  },
  {
    name: 'MsgInstantiateContract',
    text: '/cosmwasm.wasm.v1.MsgInstantiateContract',
  },
  {
    name: 'MsgSend',
    text: '/cosmos.bank.v1beta1.MsgSend',
  },
  {
    name: 'MsgSendDocumentReceipt',
    text: '/ledger.docs.MsgSendDocumentReceipt',
  },
  {
    name: 'MsgShareDocument',
    text: '/ledger.docs.MsgShareDocument',
  },
  {
    name: 'MsgStoreCode',
    text: '/cosmwasm.wasm.v1.MsgStoreCode',
  },
  {
    name: 'MsgSubmitProposal',
    text: '/cosmos.gov.v1beta1.MsgSubmitProposal',
  },
  {
    name: 'MsgTransfer',
    text: '/ibc.applications.transfer.v1.MsgTransfer',
  },
  {
    name: 'MsgUndelegate',
    text: '/cosmos.staking.v1beta1.MsgUndelegate',
  },
  {
    name: 'MsgUnjail',
    text: '/cosmos.slashing.v1beta1.MsgUnjail',
  },
  {
    name: 'MsgVote',
    text: '/cosmos.gov.v1beta1.MsgVote',
  },
  {
    name: 'MsgWithdrawDelegatorReward',
    text: '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward',
  },
  {
    name: 'MsgWithdrawValidatorCommission',
    text: '/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission',
  },
];

const SUPPORTED_TYPES = (() => {
  const config = getConfig();
  const configTypes = config?.transactions?.supportedTypes;

  if (configTypes && Array.isArray(configTypes) && configTypes.length > 0) {
    return Object.freeze(configTypes);
  }

  return Object.freeze(DEFAULT_SUPPORTED_TYPES);
})();

export default Object.freeze({
  AMOUNT_TO_LOAD: 50,
  KEY,
  MULTI_FEE: 'multi-fee',
  MULTI_TYPE: 'multi-type',
  SUPPORTED_TYPES,
});
